import '../styles/order.sass'
import { toast, Flip } from 'react-toastify'
import Pagination from '../components/Pagination'
import { AppContext } from '../context/AppContext'
import { Link, useParams } from 'react-router-dom'
import { useState, useEffect, useContext, useCallback } from 'react'
import { pqrs_subject, pqrs_impact, pqrs_states } from '../context/Variables'

const Pqrs = () => {
    const { page = 1 } = useParams()
    const [ pages, setPages ] = useState(1)
    const [ pqrs, setPqrs ] = useState(null)
    const [ post, setPost ] = useState({s: '', sort: ''})
    const { user, load, showTooltip, hideTooltip, apiURL } = useContext(AppContext)

    const updateField = useCallback((e) => {
        let _post = {...post}
        if(e.target.type == 'checkbox' && !e.target.checked)
            _post[e.target.name] = ''
        else
            _post[e.target.name] = e.target.value
        setPost(_post)
    }, [post])

    useEffect(() => {
        if(localStorage.getItem('userToken')){
            load(true)
            let formData = new FormData()
            for(let key in post)
                formData.append(key, post[key])
            formData.append('token', localStorage.getItem('userToken'))
            fetch(`${apiURL}pqrs/list/${page > 1 ? `page/${page}/` : ''}`, {method: 'POST', body: formData})
                .then(res => res.json())
                .then((data) => {
                    if(typeof data.error != 'undefined')
                        toast.error(data.error, { theme: "colored", transition: Flip })
                    else{
                        setPqrs(data.data)
                        setPages(data.pages)
                    }
                })
                .catch((e) => { toast.error('Ocurrió un error al intentar traer la información.', { theme: "colored", transition: Flip }) })
                .finally(() => load(false))
        }
        return () => hideTooltip()
    }, [page, post])

    return <section className="pqrs">
        <div className="content">
            <Link className="go-back" to="/"><span className="material-icons">arrow_back</span> Regresar</Link>
            <h1>Listado de PQRS</h1>
            <p>Consulte aquí las preguntas, quejas, reclamos y sugerencias.</p>
            <div className="filter">
                <div className="field search">
                    <span className="material-icons">search</span>
                    <input type="text" name="s" placeholder="Búsqueda rápida..." autoComplete="off" value={post?.s || ''} onChange={updateField} />
                </div>
                <div className="in-line">
                    <div className="field state">
                        <label htmlFor="impact">Impacto:</label>
                        <select name="impact" value={post?.impact || ''} onChange={updateField}>
                            <option value="">Todos</option>
                            {pqrs_impact.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                        </select>
                    </div>
                    <div className="field state">
                        <label htmlFor="subject">Motivo:</label>
                        <select name="subject" value={post?.subject || ''} onChange={updateField}>
                            <option value="">Todos</option>
                            {pqrs_subject.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                        </select>
                    </div>
                    <div className="field state">
                        <label htmlFor="state">Estado:</label>
                        <select name="state" value={post?.state || ''} onChange={updateField}>
                            <option value="">Todos</option>
                            {pqrs_states.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                        </select>
                    </div>
                    <div className="field sort">
                        <label htmlFor="sort">Ordenar por:</label>
                        <select name="sort" value={post?.sort || ''} onChange={updateField}>
                            <option value="">Radicado</option>
                            <option value="p.id">ID</option>
                            <option value="c.name">Cliente</option>
                            <option value="p.impact">Impacto</option>
                        </select>
                        <span className="material-icons">filter_alt</span>
                    </div>
                    <label htmlFor="inverse" className={`field sort-inverse ${post?.inverse}`}>
                        <span className="material-icons">arrow_drop_down</span>
                        <input type="checkbox" name="inverse" value="desc" checked={post?.inverse || ''} onChange={updateField} />
                    </label>
                </div>
            </div>
            {(pqrs?.length > 0 && <table className="list">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Cliente</th>
                        <th>Motivo</th>
                        {user?.type < 2 && <th>Comercial</th>}
                        <th>Impacto</th>
                        <th>Área</th>
                        <th>Estado</th>
                        <th>Radicado</th>
                        <th className="right">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {pqrs.map(p => <tr key={p.id}>
                        <td className="monospace">{p.id}</td>
                        <td>{p.name}</td>
                        <td>{pqrs_subject.find(s => s.id == p.subject).name}</td>
                        {user?.type < 2 && <td>{p.full_name}</td>}
                        <td>{pqrs_impact.find(i => i.id == p.impact).name}</td>
                        <td>{p.area || ''} - {p.state}</td>
                        <td>{p.state && pqrs_states.find(s => s.id == p.state).name || 'Pendiente por asignar'}</td>
                        <td>{p.created}</td>
                        <td className="right">
                            <Link className="button" to={`/pqrs/editar/${p.id}`} title="Ver pedido" onMouseEnter={showTooltip} onMouseLeave={hideTooltip} data-tooltip="Ver PQRS"><span className="material-icons">visibility</span></Link>
                        </td>
                    </tr>)}
                </tbody>
            </table>) || <table className="list">
                <thead>
                    <tr>
                        <th><center>No hay pedidos que cumplan con los filtros de búsqueda.</center></th>
                    </tr>
                </thead>
            </table>}
            <Pagination pages={pages} url="pqrs" />
            <center>
                <p>&nbsp;</p>
                <Link className="button" to="/pqrs/crear/">Crear una nueva PQRS</Link>
            </center>
        </div>
    </section>
}
export default Pqrs